<div class="container">
  <div class="grid grid-cols-12 py-6">
    <div class="col-span-6">
      <h2>Settings</h2>
    </div>

    <div class="col-span-6 flex justify-end sticky top-[72px] z-50 -mt-6 py-6">
      <div class="flex items-center justify-between">
        <button
          class="btn btn-lg shadow"
          [ngClass]="{
            'btn-danger': settingsChanged,
            'btn-primary': !settingsChanged,
          }"
          (click)="saveConfig()">
          <span class="fa fa-save"></span>
          &nbsp; Save Settings
        </button>
      </div>
    </div>

    <div class="col-span-full grid grid-cols-12 gap-4">
      <div class="col-span-8">
        <div class="form-field">
          <label for="title">Title:</label>
          <input
            type="text"
            id="title"
            name="session-title"
            [(ngModel)]="session.config.title"
            (change)="settingsChanged = true"
            maxlength="{{ appConfig.inputLengths.SESSION_TITLE }}"
            required
            pInputText />
        </div>
        <div class="form-field">
          <label for="one-liner">Short Description:</label>
          <input
            type="text"
            id="one-liner"
            name="session-oneliner"
            [(ngModel)]="session.config.one_liner"
            (change)="settingsChanged = true"
            maxlength="{{ appConfig.inputLengths.SESSION_ONE_LINER }}"
            pInputText />
        </div>
        <div class="form-field">
          <label for="description">Detailed Description:</label>
          <prosemirror
            [(content)]="session.config.descriptionRich"
            (raw)="updateRawDesc($event)"
            [characterLimit]="appConfig.inputLengths.SESSION_DESCRIPTION"
            (valid)="descValid = $event"></prosemirror>
        </div>
        <div class="form-field">
          <label for="page-size">Ideas per Page:</label>
          <input
            type="number"
            id="page-size"
            name="page-size"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config.page_size"
            min="5"
            pInputText />
        </div>
        <div class="form-field">
          <label for="layout">Ideas Layout:</label>
          <p-select
            id="layout"
            [options]="[
              { name: 'Card Layout', value: 'cards' },
              { name: 'Bar Layout', value: 'bars' },
            ]"
            optionLabel="name"
            optionValue="value"
            [(ngModel)]="session.config.layout"
            (change)="settingsChanged = true"></p-select>
        </div>
      </div>

      <div class="col-span-4">
        <div class="form-field">
          <label for="page-size">Thumbnail:</label>

          <app-image-upload
            (uploadComplete)="uploadComplete($event)"
            (uploadStart)="uploadStart()"
            [defaultImage]="
              session.config.thumbnail_id ||
              'image/default_session_thumbnail.png'
            "></app-image-upload>
        </div>
      </div>
    </div>

    <hr class="col-span-full" />

    <div class="col-span-full">
      <h2>Participants</h2>
      <div class="py-6">
        <p-dataview
          [value]="session.config.participants"
          [rows]="5"
          [paginator]="true">
          <ng-template #list let-items>
            <div
              class="participant grid grid-cols-3 gap-4 py-6"
              *ngFor="let participant of items">
              <div>
                <div class="flex items-center justify-start">
                  <profile-picture [user]="participant.user"></profile-picture>
                  <name-tag [user]="participant.user"></name-tag>
                </div>
              </div>
              <div>
                <div class="form-field" *ngIf="participant.role !== 0">
                  <p-select
                    [options]="selectableRoles"
                    optionLabel="name"
                    optionValue="value"
                    [(ngModel)]="participant.role"
                    (change)="settingsChanged = true"></p-select>
                </div>
                <div class="form-field" *ngIf="participant.role === 0">
                  <p-select
                    [options]="[{ name: 'Admin', value: 'admin' }]"
                    optionLabel="name"
                    optionValue="value"
                    readonly></p-select>
                </div>
                <div class="form-field" *ngIf="isAdmin">
                  <p-checkbox
                    inputId="can-invite"
                    [binary]="true"
                    [(ngModel)]="participant.can_invite"
                    (change)="settingsChanged = true" />
                  <label for="can-invite">Can invite other users</label>
                </div>
              </div>
              <div class="flex items-start justify-end">
                <button
                  class="btn btn-danger"
                  *ngIf="participant.role !== 0"
                  (click)="deleteParticipant(participant)">
                  Delete Participant
                </button>
              </div>
            </div>
          </ng-template>
        </p-dataview>
      </div>
      <div class="flex justify-end">
        <button class="btn btn-primary" (click)="addParticipant()">
          Add New Participant
        </button>
      </div>
    </div>

    <hr class="col-span-full" />

    <div class="col-span-full grid gap-4 grid-cols-12">
      <div class="col-span-4">
        <h2>Active Tabs</h2>

        <div class="form-field">
          <p-checkbox
            inputId="show-projects"
            [binary]="true"
            [(ngModel)]="session.config.ideas.active"
            (change)="settingsChanged = true" />
          <label for="show-projects">Show Projects</label>
        </div>
        <!-- <div class="checkbox">
        <label>
          <input
            type="checkbox"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config.matrix.active" />
          Show Ratings
        </label>
      </div> -->
        <div class="form-field">
          <p-checkbox
            inputId="show-people"
            [binary]="true"
            [(ngModel)]="session.config.people.active"
            (change)="settingsChanged = true" />
          <label for="show-people">Show People</label>
        </div>
        <div class="form-field">
          <p-checkbox
            inputId="pdf-exports"
            [binary]="true"
            [(ngModel)]="session.config.pdf_exports.active"
            (change)="settingsChanged = true" />
          <label for="pdf-exports">Show Session Report</label>
        </div>
      </div>

      <div class="col-span-5">
        <h2>Additional Settings</h2>

        <!-- <div class="checkbox">
        <label>
          <input
            type="checkbox"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config.voting.active" />
          Enable Voting
        </label>
      </div> -->
        <!-- <div class="checkbox">
        <label>
          <input
            type="checkbox"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config['vote_own_ideas']" />
          Enable Rating own ideas
        </label>
      </div> -->
        <div class="form-field">
          <p-checkbox
            inputId="enable-comments"
            [binary]="true"
            [(ngModel)]="session.config.comments.active"
            (change)="settingsChanged = true" />
          <label for="enable-comments">Enable Comments</label>
        </div>
        <div class="form-field">
          <p-checkbox
            inputId="suggest-tags"
            [binary]="true"
            [(ngModel)]="session.config.suggest_tags"
            (change)="settingsChanged = true" />
          <label for="suggest-tags">
            Enable English Tag Suggestion for Ideas
          </label>
        </div>
        <div class="form-field">
          <p-checkbox
            inputId="dont-invite-by-default"
            [binary]="true"
            [(ngModel)]="session.config.dont_invite_by_default"
            (change)="settingsChanged = true" />
          <label for="dont-invite-by-default">
            Disabled By Default in Invites
          </label>
        </div>

        <hr />

        <div class="form-field">
          <label for="visibility" for>Visibility:</label>
          <small>
            The topic will be visible to anyone with selected role or stronger.
          </small>
          <p-select
            id="visibility"
            [options]="visibilityRoles"
            optionLabel="name"
            optionValue="value"
            [(ngModel)]="session.config.visibility"
            (change)="settingsChanged = true"></p-select>
        </div>
        <div class="form-field">
          <p-checkbox
            inputId="deactivated"
            [binary]="true"
            [(ngModel)]="session.config.deactivated"
            (change)="settingsChanged = true" />
          <label for="deactivated">Deactivated</label>
        </div>
        <div class="form-field">
          <label class="form-label" for="deactivation_message">
            <small>
              Deactivated topics will be marked as deactivated for participants,
              thoguh they will still retain access to them.
            </small>
          </label>
          <textarea
            id="deactivation_message"
            [(ngModel)]="session.config.deactivation_message"
            (change)="settingsChanged = true"
            [disabled]="!session.config.deactivated"
            placeholder="Why is this topic deactivated?"
            pTextarea></textarea>
        </div>
      </div>

      <div class="col-span-3" *ngIf="session.config.organizer">
        <h2>Organizer</h2>
        <div class="form-field">
          <p-checkbox
            inputId="show-organizer"
            [binary]="true"
            [(ngModel)]="session.config.organizer.enabled"
            (change)="settingsChanged = true" />
          <label for="show-organizer">Show Organizer</label>
        </div>

        <div class="form-field">
          <label class="form-label" for="orginizer">Organizer:</label>
          <input
            id="orginizer"
            (change)="settingsChanged = true"
            [(ngModel)]="session.config.organizer.name"
            pInputText />
        </div>
        <div class="form-field">
          <app-image-upload
            (uploadStart)="uploadStart()"
            (uploadComplete)="logoUploadComplete($event)"
            [defaultImage]="
              session.config.organizer.logo_id
            "></app-image-upload>
        </div>
      </div>
    </div>
  </div>
</div>
